/**
 * The two directions are mirror images: whichever system sits on the left, its
 * fields land in the erp* keys or the ecommerce* keys of the saved mapping. These
 * helpers let one set of components render either direction.
 */

const ERP_SIDE = {
    name: 'erpAttributeName',
    dataType: 'erpAttributeDataType',
    isRequired: 'erpIsRequired',
    size: 'erpAttributeSize',
    type: 'erpAttributeType'
}

const ECOMMERCE_SIDE = {
    name: 'ecommerceAttributeName',
    dataType: 'ecommerceAttributeDataType',
    isRequired: 'ecommerceIsRequired',
    size: 'ecommerceAttributeSize',
    type: 'ecommerceAttributeType'
}

export const leftKeys = (direction) => (direction.leftIsErp ? ERP_SIDE : ECOMMERCE_SIDE)
export const rightKeys = (direction) => (direction.leftIsErp ? ECOMMERCE_SIDE : ERP_SIDE)

/** Reads one side of a mapping as a plain { name, dataType, isRequired, ... } object. */
const readSide = (mapping, keys) => ({
    name: mapping[keys.name],
    dataType: mapping[keys.dataType],
    isRequired: mapping[keys.isRequired],
    size: mapping[keys.size],
    type: mapping[keys.type]
})

export const leftSide = (mapping, direction) => readSide(mapping, leftKeys(direction))
export const rightSide = (mapping, direction) => readSide(mapping, rightKeys(direction))

const writeSide = (target, keys, field) => {
    target[keys.name] = field.name
    target[keys.dataType] = field.dataType
    target[keys.isRequired] = Boolean(field.isRequired)
    target[keys.size] = field.size
    target[keys.type] = field.type
}

/** Builds a full mapping from a picked field on each side. */
export const buildMapping = (direction, leftField, rightField) => {
    const mapping = { default: Boolean(rightField.isDefault) }
    writeSide(mapping, leftKeys(direction), leftField)
    writeSide(mapping, rightKeys(direction), rightField)
    return mapping
}

/** Replaces just one side's name/metadata, used when a row's dropdown changes. */
export const withSideField = (mapping, direction, side, field) => {
    const next = { ...mapping }
    writeSide(next, side === 'left' ? leftKeys(direction) : rightKeys(direction), field)
    return next
}

/** The field lists for each column, in the order this direction shows them. */
export const sideFields = (direction, erpFields, ecommerceFields) => ({
    left: direction.leftIsErp ? erpFields : ecommerceFields,
    right: direction.leftIsErp ? ecommerceFields : erpFields
})

/** A field may not be mapped to a target whose data type it lists in notAllowed. */
export const isNotAllowed = (leftField, rightField) =>
    Boolean(leftField)
    && leftField.notAllowed.length > 0
    && leftField.notAllowed.indexOf(rightField.dataType) !== -1
